import React from 'react'

import * as S from './styles'

const RequiredIndicator = () => {
  return <S.Asterisk>*</S.Asterisk>
}

export default RequiredIndicator
